/**
 * In-app links: real `href`s (so open-in-new-tab works) whose plain clicks
 * the app routes itself. One rule for every such link (the top bar's
 * navigation, a rundown's name in the list).
 */

/** The parts of a click the decision reads (React's and the DOM's mouse events both have them). */
export type ClickLike = {
  readonly button: number;
  readonly metaKey: boolean;
  readonly ctrlKey: boolean;
  readonly shiftKey: boolean;
  readonly altKey: boolean;
};

/** A plain left click navigates in-app; a modified click (new tab, new window, download) is left to the browser. */
export function isPlainClick(event: ClickLike): boolean {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}
